/**
 * Whether the sheet this sits in is dark.
 *
 * Read off the modal's own fill rather than the system scheme: a host can pin
 * one theme for both schemes — fomo draws dark on a light phone — and the SDK
 * has to match the surface it is drawn on, not the OS.
 */
export function isDarkColor(color: string): boolean {
  const hex = /^#([0-9a-f]{6})/i.exec(color)?.[1]
  if (hex === undefined) {
    return false
  }
  const value = Number.parseInt(hex, 16)
  // Rec. 601 luma, which is what "is this dark" means to an eye.
  const luma =
    0.299 * ((value >> 16) & 0xff) +
    0.587 * ((value >> 8) & 0xff) +
    0.114 * (value & 0xff)
  return luma < 128
}
